import type { FC } from 'react'
import cn from 'classnames'
import { Checkbox } from 'components/ui'
import { CategorySlug } from 'framework/categories'
import { useRouter } from 'next/router'
import type { FilterCheckListProps } from '.'
import s from './filter-check-list.module.css'
import { FilterBlock } from '..'

const FilterCheckList: FC<FilterCheckListProps> = ({
  title = '',
  param,
  className,
  filters,
  vertical = false,
  handle,
  checkedOptions,
}) => {
  const router = useRouter()
  const currentPath = router.pathname
  const currentQuery = router.query
  const values = currentQuery[param]
    ? ((currentQuery[param] as unknown as string).split(',') as unknown as string[])
    : []

  function handleChange(slug: CategorySlug, checked: boolean) {
    if (checked) {
      const find = values.find((item) => item === slug)
      if (!find) {
        const next = [...values]
        next.push(slug)
        currentQuery[param] = next.join(',')
      }
    } else {
      const next = [...values.filter((item) => item !== slug)]
      currentQuery[param] = next.join(',')
    }

    if (handle) {
      handle(slug)
    } else {
      router.push({
        pathname: currentPath,
        query: currentQuery,
      })
    }
  }

  if (!filters) {
    return <></>
  }

  return (
    <FilterBlock title={title} className={cn(s.root, className)} vertical>
      <div className={cn(vertical && s.vertical)}>
        {filters.map(({ id, name, slug }) => (
          <Checkbox
            name={`filter-checkbox-${id}`}
            value={slug}
            label={name}
            checked={
              checkedOptions ? !!checkedOptions.find((i: string) => i === slug) : !!values.find((i) => i === slug)
            }
            handleChange={handleChange}
            className={s.checkbox}
          />
        ))}
      </div>
    </FilterBlock>
  )
}

export default FilterCheckList
